import React, {useState } from 'react';
import BsModal from '../../Common/BsModal';
import ActivityLoader from '../../Common/ActivityLoader';
import TextInput from '../../Common/TextInput';
import Notification from '../../Common/Notification';
import { useReport } from '../../../DataStore/ReportContext';
import { useTheme } from '../../../DataStore/ThemeContext';

const PopTestConfig = () => {

    const [loading, setLoading] = useState(false);
    const [info, setInfo] = useState(false);
    const [mark, setMark] = useState('');
    const { setNotify } = useTheme();
    


    const {setReportTest, reportTestConfig, setSelectedTests, selectedTests} = useReport();

   
     const confirm=(e)=>{
        e.preventDefault();
  
        if(mark>0){
            setExamMark({
                "out_of":mark,
                "test_id":reportTestConfig.value,
                "exam_name":reportTestConfig.label
            })
            setReportTest(false);
            setMark('');
        }else{
            setInfo(<Notification type="danger" message="Enter test mark and try again"/>);
        }
       
        
    }

    const  onChangeMark=(event)=>{
       setMark(event.target.value)
    }

    const setExamMark=(selectedExam)=>{
       const newSelection = [];
       for(var i=0; i<selectedTests.length; i++)
       {    
            newSelection.push(selectedTests[i]);
            if(selectedTests[i].test_id*1 === selectedExam.test_id*1)
            {
                setNotify(<Notification type="info" message={"Exam already added to this report"}/>)
                // return false;
                //Replace the exam mark if it already exists
                selectedTests[i].out_of = selectedExam.out_of;
                return;
            }
       }
       newSelection.push(selectedExam)
       setSelectedTests(newSelection)
   }


   const handleClose = ()=>{
        setNotify(false);
        setReportTest(false);
   }

    return (
        <BsModal
            show={reportTestConfig ? true : false}
            onClose={handleClose}
            title={`Configure ${reportTestConfig ? reportTestConfig.label : ''} Exam`}
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-secondary" onClick={() => setReportTest(false)}>
                        Cancel
                    </button>
                    <button className="btn btn-success" onClick={confirm}>
                        Include Exam
                    </button>
                    </>}
                </>
            }
        >


        {info}
        <TextInput
            type="text"
            label="Exam Contribution Mark"
            placeholder="Enter Exam Mark e.g. 30, 40"
            leftIcon="fa fa-bookmark"
            value={mark}
            onChange={onChangeMark} 
            required
            wrap
            />
            
        </BsModal>
    );
};

export default PopTestConfig;
